export default __webpack_public_path__ + "images/20df7fec6c7871060cdc8c2ed2f2e2d2-halloween_seasonal_desktop.webp";